import React, { useMemo } from 'react'
import PropTypes from 'prop-types'
import { View } from 'react-native'
import Txt from '../Txt'
import Menu from '../Menu'
import Icon from '../Icons'
import { useTheme } from '../../theming/ThemeProvider'
import { usePlatforms } from '../../hooks/usePlatforms'
import Identity from '../../utils/Identity'
import LocationsInformation from './LocationsInformation'
import useStyles from './useStyles'
import { getCardsLocationText } from '../../tools/dataParse'

const MyCard = ({ item, openDelete, openModal }) => {
  const { name, tractor_number, trailer_number, status, location, email, phone_number, comments } = item
  const { isTablet, isDesktop } = usePlatforms()

  const menuItems = [
    {
      text: 'Edit',
      fn: () => openModal(item)
    },
    {
      text: 'Delete',
      fn: () => openDelete(item)
    }
  ]

  const { theme } = useTheme()
  const styles = useStyles(theme, isTablet, isDesktop)
  const isAvaliable = +status === 1

  const Status = useMemo(() => (
    <View
      style={[
        styles.status,
        {
          marginBottom: isDesktop ? 0 : 5,
          backgroundColor: theme[isAvaliable ? 'FERN' : 'RED_ORANGE']
        }]}
    >
      <Txt
        color='WHITE_TEXT'
        text={isAvaliable ? 'Avaliable' : 'Unavaliable'}
        identity='body3Bold'
      />
    </View>
  ), [isAvaliable, isDesktop, styles.status, theme])

  return (
    <View
      style={[styles.cardStyle, Identity.Shadow(theme).Card]}
    >
      {isTablet && Status}
      <View style={{ flex: 1, flexDirection: 'row', flexWrap: 'wrap' }}>
        <View style={[styles.location, isTablet && { flex: 2, marginTop: 10 }]}>
          <LocationsInformation
            isDriver
            origin={getCardsLocationText(location)}
            destination={name}
            isTablet={isTablet}
            style={{
              flexDirection: isDesktop ? 'row-reverse' : 'column-reverse'
            }}
          />
        </View>
        <View
          style={[
            styles.information,
            {
              flexDirection: isTablet ? 'row' : 'column',
              flex: isTablet ? 3 : 1
            }
          ]}
        >
          {!isTablet && Status}
          {isTablet && (
            <View style={{ flex: 2 }}>
              <View style={[styles.number, isTablet && { marginBottom: 10 }]}>
                <Txt
                  color='OUTER_SPACE'
                  text={phone_number}
                  identity='body2'
                />
                <Txt
                  color='SLATE_GRAY'
                  text='Phone'
                  identity='body3'
                />
              </View>
              <View style={[styles.number, isTablet && { marginBottom: 10 }]}>
                <Txt
                  color='OUTER_SPACE'
                  text={email}
                  identity='body2'
                />
                <Txt
                  color='SLATE_GRAY'
                  text='Email'
                  identity='body3'
                />
              </View>
            </View>
          )}
          <View style={{ flex: 1 }}>
            <View style={[styles.number, isTablet && { marginBottom: 10 }]}>
              <Txt
                color='OUTER_SPACE'
                text={isTablet ? (tractor_number || '--') : 'Tractor Nº'}
                identity={isTablet ? 'body2' : 'body2Bold'}
              />
              <Txt
                color='SLATE_GRAY'
                text={isTablet ? 'Tractor Nº' : (tractor_number || '--')}
                identity='body3'
              />
            </View>
            <View style={[styles.number, isTablet && { marginBottom: 10 }]}>
              <Txt
                color='OUTER_SPACE'
                text={isTablet ? (trailer_number || '--') : 'Trailer Nº'}
                identity={isTablet ? 'body2' : 'body2Bold'}
              />
              <Txt
                color='SLATE_GRAY'
                text={isTablet ? 'Trailer Nº' : (trailer_number || '--')}
                identity='body3'
              />
            </View>
          </View>
          {isDesktop && (
            <View style={{ flex: 1 }}>
              <View style={[styles.number, isTablet && { marginBottom: 10 }]}>
                <Txt
                  color='OUTER_SPACE'
                  text={comments}
                  identity='body2'
                />
                <Txt
                  color='SLATE_GRAY'
                  text='Comments'
                  identity='body3'
                />
              </View>
            </View>
          )}
        </View>
      </View>
      <Menu
        items={menuItems} style={{
          width: isDesktop ? 30 : 25,
          height: isDesktop ? 30 : 25,
          borderRadius: 100,
          backgroundColor: theme.GALLERY,
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          marginLeft: 15
        }}
      >
        <Icon
          fill={theme.SLATE_GRAY_TEXT}
          name='ShowMore'
          height={isDesktop ? 20 : 18}
          width={isDesktop ? 20 : 18}
        />
      </Menu>
    </View>
  )
}

MyCard.defaultProps = {
  isBidAndBook: []
}

MyCard.propTypes = {
  item: PropTypes.object.isRequired,
  openDelete: PropTypes.func.isRequired,
  openModal: PropTypes.func.isRequired
}

function areEqual (prevProps, nextProps) {
  if (prevProps.item?.movementNumber) {
    return prevProps.item?.movementNumber === nextProps.item?.movementNumber
  }
  return false
}

export default React.memo(MyCard, areEqual)
